import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss']
})
export class BackToTopComponent implements OnInit {
  backToTop: boolean = true;
  @HostListener('window:scroll', ['event']) scroll() {
    setTimeout(() => {
      if(window.pageYOffset > 200){
        this.backToTop = false;
      }else{
        this.backToTop = true;
      }
    }, 200);
  }

  constructor() { }

  ngOnInit(): void {
  }

  goToTop(){
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

}
